import screen from "./screen/home";
const screens =[screen]
export default screens;
